import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { ConnectionAreaUsageVO, MetaElementUsageIdentityVO } from '@shared/vo/meta-element.vo';
import { Connection } from '@3d-scene/model3d/connection';
import { LabelingArticleConnectProcessor } from './labeling-article-connect.processor';
import { Injectable } from '@angular/core';
import { ArticleContainerFactory } from '@3d-scene/model3d/article-container.factory';
import { ArticleContainerUtils } from '@3d-scene/model3d/util/article-container-utils';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { ArticleManager } from '@article/manager/article.manager';
import { CompositeArticleCacheManager } from '@article/manager/composite-article-cache.manager';
import { ArticleContainerLoader } from '@article/service/article-container-loader';
import { CompositeArticleUtils } from '@article/util/composite-article-utils';
import { LabelingArticleRotationHelper } from '@project/components/label/helper/labeling-article-rotation.helper';
import { LabelEditorStateManager } from '@project/components/label/label-editor/service/label-editor-state.manager';
import { OpenLabelEditorService } from '@project/components/label/label-editor/service/open-label-editor.service';
import { ProjectModel } from '@project/model/project.model';
import { ProjectModelService } from '@project/service/project-model.service';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';
import { LabelingArticleConversionDataManager } from '../../../manager/labeling-article-conversion-data.manager';
import { ProjectArticleService } from '@project/service/project-article.service';
import { SelectionModelService } from '../../../service/selection-model.service';
import { ProjectMetaElementService } from '@project/manager/project-meta-element.service';
import { RotateArticlePresenter } from '../../../presenter/rotate-article.presenter';
import { ProjectHelper } from '@project/helper/project.helper';
import { DetachArticleUsageService } from '@project/service/detach-article-usage.service';
import { ConnectionAreaUsageUtils } from '@shared/util/connection-area-usage-utils';
import { ConnectionInfoService } from '@3d-scene/model3d/service/connection-info.service';
import { CompositeArticleInfoUtils } from '@article/util/composite-article-info-utils';

@Injectable({ providedIn: 'root' })
export class UnusedLabelingArticleConnectProcessor extends LabelingArticleConnectProcessor {
  constructor(
    projectModel: ProjectModel,
    projectModelService: ProjectModelService,
    protected projectArticleService: ProjectArticleService,
    protected projectMetaElementService: ProjectMetaElementService,
    localeResourceManager: LocaleResourceManager,
    articleContainerLoader: ArticleContainerLoader,
    compositeArticleCacheManager: CompositeArticleCacheManager,
    articleContainerFactory: ArticleContainerFactory,
    articleManager: ArticleManager,
    compositeArticleUtils: CompositeArticleUtils,
    compositeArticleInfoUtils: CompositeArticleInfoUtils,
    connectionInfoService: ConnectionInfoService,
    containerService: ContainerService,
    articleContainerUtils: ArticleContainerUtils,
    detachArticleUsageService: DetachArticleUsageService,
    projectHelper: ProjectHelper,
    labelingArticleRotationHelper: LabelingArticleRotationHelper,
    dataManager: LabelingArticleConversionDataManager,
    selectionModelService: SelectionModelService,
    labelEditorStateManager: LabelEditorStateManager,
    openLabelEditorService: OpenLabelEditorService,
    rotateArticlePresenter: RotateArticlePresenter,
  ) {
    super(
      projectModel,
      projectModelService,
      projectArticleService,
      projectMetaElementService,
      localeResourceManager,
      articleContainerLoader,
      compositeArticleCacheManager,
      articleContainerFactory,
      articleManager,
      compositeArticleUtils,
      compositeArticleInfoUtils,
      connectionInfoService,
      containerService,
      articleContainerUtils,
      detachArticleUsageService,
      projectHelper,
      labelingArticleRotationHelper,
      dataManager,
      selectionModelService,
      labelEditorStateManager,
      openLabelEditorService,
      rotateArticlePresenter,
    );
  }
  protected createMetaElementUsages(
    containers: ArticleContainer[],
    givingConnectionCubes: Connection[],
    acceptingConnectionCubes: Connection[]
  ): void {
    for (let i: number = 0; i < givingConnectionCubes.length; i++) {
      this.createUsageForGivingConnection(givingConnectionCubes[i], acceptingConnectionCubes[i]);
    }
    this.articleContainerUtils.updateActiveSetInArticleContainers(containers);
    this.labelingArticleRotationHelper.rotateLabelingArticle(this.rotateArticlePresenter, containers[0], false, false);
  }

  private createUsageForGivingConnection(givingCube: Connection, acceptingCube: Connection): void {
    const givingArticleContainer: ArticleContainer = this.containerService.getArticleContainer(givingCube);
    const acceptingArticleContainer: ArticleContainer = this.containerService.getArticleContainer(acceptingCube);
    if (!givingCube.metaElementUsage) {
      givingCube.metaElementUsage = this.projectMetaElementService.addMetaElementUsageToArticleUsage(
        givingCube.metaElementVO,
        givingArticleContainer.articleUsage
      );
    }
    const givingConnectionAreaUsage: ConnectionAreaUsageVO = givingCube.metaElementUsage as ConnectionAreaUsageVO;
    ConnectionAreaUsageUtils.setBackwardConnection(givingConnectionAreaUsage, MetaElementUsageIdentityVO.create(acceptingArticleContainer.articleGUID, acceptingCube.metaElementVO.name))
  }

  protected finalizeAttachArticleContainer(givingArticleContainers: ArticleContainer[], acceptingConnectionCubes: Connection[]): void {}
}
